import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate, useLocation } from "react-router-dom";
import { getContactDetails, replyContactUs, getS3Config } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import { Editor } from '@tinymce/tinymce-react';

export function Replymessage() {

    const location = useLocation();
    const extracted = location.pathname.split('/');
    let contact_id = atob(extracted[3]);
    let navigate = useNavigate();
    const timezone = localStorage.getItem('timezone');

    const titleStyle = { background: 'linear-gradient(180deg, #D7C9A1, #D7C9A1)', padding: '5px 20px', borderRadius: '20px' };
    const boxStyle = { border: '2px solid #D7C9A1', padding: '5px 20px', borderRadius: '20px' };

    const [contactDetails, setContactDetails] = useState(null);
    const editorRef = useRef(null);
    const [editorData, setEditorData] = useState(`<p></p>`);
    const [ s3Config, setS3Config ] = useState({});

    // Fetch data from server
    const fetchData = async () => {
        try {
            
            const confResponse = await getS3Config({});
            if (parseInt(confResponse.code) === 1) {
                setS3Config(confResponse.data);
            }

            const userReq = {
                contact_id: contact_id
            }
            const response = await getContactDetails(userReq);
            if (parseInt(response.code) === 1) {
                setContactDetails(response.data);
                setEditorData(`
                    <p>Hello <strong>${response?.data?.first_name},<strong></p>
                    <p>Thank you for contacting Support at Alchemy Markets!</p>
                    <p style="color: rgb(0, 0, 0);"><strong>[[YOUR MAIN CONTENT GOES HERE...]]</strong></p>
                    <p>Thank you for your patience and understanding.</p>
                    <p style="color: rgb(0, 0, 0);">Best Regards,<br>Alchemy Markets Support</p>
                    <p style="color: rgb(0, 0, 0);"></p>
                `)
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading contact us, please try again later");
        }
    };

    useEffect(() => {
        $('.image-popup').magnificPopup({
            type: 'image',
            gallery: {
              enabled: true
            }
        });
        fetchData();
    }, [ s3Config ]);

    const handleGoBack = () => {
        navigate(-1);
    };

    const handleReplyRequest = async(e) => {
        e.preventDefault();
        
        // get updated editor data
        setEditorData(editorRef.current.getContent());

        const contactReply = {
            contact_id: contact_id,
            content_value: editorRef.current.getContent(),
        };
        const response = await replyContactUs(contactReply);
        if (parseInt(response.code) === 1) {
            showMessage(response.message);
            navigate('/contactus/listing');
        } else {
            showErrorMessage(response.message);
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Contact Us details</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                        <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/contactus/listing">
                                        Contact Us
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Contact Us details</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="header">
                                    <div className="col-12 text-left">
                                        <a 
                                            href="#"
                                            onClick={handleGoBack} 
                                            className="btn btn-raised bg-primary waves-effect waves-red text-left"
                                        >
                                                <i className="zmdi zmdi-arrow-left"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="body">                                    
                                    <form name="replyMessage" id="replyMessage" onSubmit={handleReplyRequest}>
                                        <div className="row">
                                            <div className="col-md-4 col-lg-4 col-xl-4" style={{width: '50%'}}>
                                                <h4 className="m-t-0" style={ titleStyle }>
                                                    <b>CONTACT US DETAILS</b>
                                                </h4>
                                                <hr />
                                                <div className="p-20" style={ boxStyle }>
                                                    <div className="about-info-p mb-2">
                                                        <strong>First Name</strong> <br />
                                                        <p className="text-muted">
                                                            <span className="text-muted">{contactDetails ? contactDetails.first_name : ''}</span>
                                                        </p>
                                                    </div>
                                                    <div className="about-info-p mb-2">
                                                        <strong>Last Name</strong> <br />
                                                        <p className="text-muted">
                                                            <span className="text-muted">{contactDetails ? contactDetails.last_name : ''}</span>
                                                        </p>
                                                    </div>
                                                    <div className="about-info-p mb-2">
                                                        <strong>Email</strong> <br />
                                                        <p className="text-muted">
                                                            <span className="text-muted">{contactDetails ? contactDetails.email : ''}</span>
                                                        </p>
                                                    </div>
                                                    <div className="about-info-p mb-2">
                                                        <strong>Subject</strong> <br />
                                                        <p className="text-muted">
                                                            <span className="text-muted">{contactDetails ? contactDetails.subject : ''}</span>
                                                        </p>
                                                    </div>
                                                    <div className="about-info-p mb-2">
                                                        <strong>Message</strong> <br />
                                                        <p className="text-muted">
                                                            <span className="text-muted">{contactDetails ? contactDetails.message : ''}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-8 col-lg-8 col-xl-8" style={{width: '50%'}}>
                                                <h4 className="m-t-0" style={ titleStyle }>
                                                    <b>REPLY MESSAGE</b>
                                                </h4>
                                                <hr />
                                                <div className="p-20" style={ boxStyle }>
                                                    { s3Config.REACT_APP_TINYMCE_API_KEY ? (
                                                        <Editor
                                                            apiKey={s3Config.REACT_APP_TINYMCE_API_KEY}
                                                            onInit={(_evt, editor) => editorRef.current = editor}
                                                            initialValue={editorData.toString()}
                                                            init={{
                                                                height: 300,
                                                                menubar: false,
                                                                plugins: [
                                                                    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                                                    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                                                    'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                                                                ],
                                                                toolbar: 'undo redo | blocks | ' +
                                                                    'bold italic forecolor | alignleft aligncenter ' +
                                                                    'alignright alignjustify | bullist numlist outdent indent | ' +
                                                                    'removeformat | help',
                                                                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                                                            }}
                                                        />
                                                    ) : (
                                                        <p>Loading editor...</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix" />
                                        <div className="col-md-2 col-lg-2 col-xl-2 offset-md-5">
                                            <div className="form-group">
                                                <button type="submit" className="btn btn-raised btn-primary waves-effect m-t-20 mr-3">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}